<template>
  <div>
    <template v-if="institution && !institution.kl_assessment">
      <Page404></Page404>
    </template>
    <template v-else>
      <NavigationBreadcrumb
        :items="breadcrumb_items"
        :sectionId="section ? section.id : null"
        :sticky="false"
        :showMatterProgram="true"
        :showNewFullGradingView="true"
        :showAssessmentStudents="true"
        :showEvaluatorEvaluations="true"
        :showAssessmentRangeSectionView="true"
        :showProfessorProgressionReportView="true"
      ></NavigationBreadcrumb>
      <NewEvaluation
        :allows_crud="false"
        :evaluation_id="evaluation_id"
        :instrument_id="instrument_id"
        :evaluator_view="true"
      ></NewEvaluation>
    </template>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import api from "@/utils/api";
import matterLanguageMixin from "@/mixins/matterLanguageMixin";

export default {
  name: "EvaluatorView",
  mixins: [matterLanguageMixin],
  components: {
    NewEvaluation: () =>
      import("@/components/new-evaluations/Evaluation/NewEvaluation"),
    Page404: () => import("@/components/public/Page404"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {},
  data() {
    return {
      evaluation_id: Number(this.$route.params.evaluation_id),
      instrument_id: Number(this.$route.params.instrument_id),
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      user: "getUser",
      evaluations: names.NEW_EVALUATIONS,
      sections: names.SECTIONS,
    }),
    evaluation() {
      return this.evaluations.find((x) => x.id == this.evaluation_id);
    },
    section() {
      if (this.evaluation && this.evaluation.scope == 1)
        return this.sections.find((x) => x.id == this.evaluation.scope_id);
      else return null;
    },
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "evaluations2.evaluation",
            false,
            "Evaluación"
          ),
          dropdownOptions: [
            "showMatterProgram",
            "showAssessmentStudents",
            "showEvaluatorEvaluations",
            "showAssessmentRangeSectionView",
            "showNewFullGradingView",
            "showProfessorProgressionReportView",
          ],
        },
      ];
    },
  },
  methods: {
    // Profesor que abre la evaluación de una sección que no dicta: vuelve al inicio con un aviso
    redirectIfSectionNotAssigned(evaluation) {
      if (
        !this.user ||
        !this.user.group_names ||
        !this.user.group_names.includes("PROFESORES")
      )
        return;
      if (evaluation.scope != 1 || evaluation.scope_id == null) return;
      // Sin FETCH_SECTION (no rechaza ante errores): a un profesor, una sección ajena le da 404
      api.get(`/teaching/section/${evaluation.scope_id}/`).catch((error) => {
        if (!error.response || error.response.status != 404) return;
        this.$router.replace({ name: "DashboardView" });
        this.$swal.fire({
          icon: "info",
          title: this.$t("evaluations.newEvaluations.evaluationNotAssignedTitle", {
            entity: this.$getVisibleNames(
              "evaluations2.evaluation",
              false,
              "Evaluación"
            ).toLowerCase(),
          }),
          text: this.$t("evaluations.newEvaluations.evaluationNotAssignedText"),
        });
      });
    },
  },
  mounted() {},
  watch: {},
  created() {
    this.$store.dispatch(names.FETCH_NEW_TEST_TYPES);
    this.$store.dispatch(names.FETCH_REDACTION_QUESTION_LENGTH_ANSWERS);
    this.$store.dispatch(names.FETCH_MULTIPLE_QUESTION_SCORE_TYPES);
    this.$store.dispatch(names.FETCH_RUBRIC_PRESETS);
    this.$store.dispatch(names.FETCH_RUBRIC_PRESET_UNITS);
    this.$store.dispatch(names.FETCH_NEW_FILLING_QUESTION_SUB_TYPES);
    this.$store.dispatch(names.FETCH_TAXONOMIES);
    this.$store
      .dispatch(names.FETCH_NEW_EVALUATION, this.evaluation_id)
      .then((evaluation) => {
        this.applyLanguageForEvaluation(evaluation);
        this.redirectIfSectionNotAssigned(evaluation);
      });
  },
};
</script>

<style scoped>
</style>